import { Injectable } from '@angular/core';

// Define a service holding the language. You probably already have one if your app is i18ned.
@Injectable()
export class I18n {
  language = 'pl';
}